import {Component, Input, OnInit} from '@angular/core';
import {PaymentDetailsInterface} from '../../../shared/models/payment-details.interface';
import {ConstsHelper} from '../../../../helpers/consts.helper';

@Component({
    selector: 'app-new-payment-card',
    templateUrl: './new-payment-card.component.html',
    styleUrls: ['./new-payment-card.component.css'],
    standalone: false
})
export class NewPaymentCardComponent implements OnInit {

  @Input()
  procedureCode: string;
  paymentDetailsInterface: PaymentDetailsInterface;

  constructor() {}

  ngOnInit() {
    this.paymentDetailsInterface = {
      errorMessage: ConstsHelper.ERROR_MESSAGE_SAVE_PAYMENT_CARD,
      procedureCode:  this.procedureCode,
      redirectLink: '/compte/paiement',
      type: 'nouvelle_carte',
      procedureType: 'account',
      externalId: null,
      selectedLine: null,
      payload: {routeValue: 'cb_pay_method_change'},
      amount: 1
    } as PaymentDetailsInterface;
  }
}
